import React from "react";
// import './FloatingLoader.css'
// import Logo from "../../assets/images/bet-frenzy/Betfrenzy Logo Transparent.png";
import LogoGIF from "../../assets/images/bet-frenzy/New-GIF-Betfrenzy_1.gif"

const FloatingLoader = () => {
  const symbols = [
    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },
    { char: "Ξ", color: "#627eea", delay: 1 },
    { char: "₮", color: "#26a17b", delay: 1.5 },
    { char: "Ł", color: "#bfbbbb", delay: 2 },
    { char: "◊", color: "#8c4af0", delay: 2.5 },
    { char: "Ⓧ", color: "#344675", delay: 3 },
    { char: "Ⓜ", color: "#ff6600", delay: 3.5 },
    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },
    { char: "Ξ", color: "#627eea", delay: 1 },
    { char: "₮", color: "#26a17b", delay: 1.5 },
    { char: "Ł", color: "#bfbbbb", delay: 2 },
    { char: "◊", color: "#8c4af0", delay: 2.5 },
    { char: "Ⓧ", color: "#344675", delay: 3 },
    { char: "Ⓜ", color: "#ff6600", delay: 3.5 },
  ];

  return (
    <div className="floating-loader">
      {/* <div className="floating-symbols">
        {symbols.map((symbol, index) => (
          <div
            key={index}
            className="floating-symbol"
            style={{
              color: symbol.color,
              animationDelay: `${symbol.delay}s`,
              left: `${Math.random() * 80 + 10}%`,
              top: `${Math.random() * 80 + 10}%`,
            }}
          >
            {symbol.char}
          </div>
        ))}
      </div> */}
      <div>
        <img
          src={LogoGIF}
          alt=""
          className="cursor-pointer my-4"
          style={{ width: "150px", height: "100px" }}
        />
        {/* <div className="loader-center">
          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
          <div className="loading-text">Loading</div>
        </div> */}
      </div>
    </div>
  );
};

export default FloatingLoader;
